import api from './api';
import type { MenuFormatExecutionSummary } from '../types/execution';

/**
 * Phase 7.A.1 — READ-ONLY MenuItemFormat execution summary.
 *
 * Mounted at:
 *   /admin/venue/:venueId/menu/:menuId/items/:itemId/formats/:formatId/execution
 *
 * NOTE: this base path is distinct from menuItemFormatService
 * (/menu-item/:itemId/formats) — it needs `menuId`, which the Menu item forms
 * already have. The endpoint performs no writes.
 *
 * This endpoint only exists on the backend Phase 7.A branch (PR #6). Until that
 * is merged/deployed to shared dev, callers must tolerate a 404 — see
 * FormatExecutionBlock, which renders a soft "unavailable" state rather than
 * crashing the menu form.
 */
const menuFormatExecutionService = {
  getFormatExecution: async (
    venueId: string,
    menuId: string,
    itemId: string,
    formatId: string,
    locationId?: string,
  ): Promise<MenuFormatExecutionSummary> => {
    const response = await api.get(
      `/admin/venue/${venueId}/menu/${menuId}/items/${itemId}/formats/${formatId}/execution`,
      { params: locationId ? { locationId } : undefined },
    );
    return response.data;
  },
};

export default menuFormatExecutionService;
